import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/pro-solid-svg-icons';

type Props = {
  open: boolean;
  memberCount?: number;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ChannelMentionConfirmation = ({
  open,
  memberCount,
  onConfirm,
  onCancel,
}: Props) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle className="flex items-center gap-2">
      <FontAwesomeIcon icon={faUsers} className="text-purple-500" />
      Notify all members?
    </DialogTitle>
    <DialogContent>
      <Typography>
        {memberCount
          ? `This will send a notification to all ${memberCount} members of this community.`
          : 'This will send a notification to all members of this community.'}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color="inherit">
        Cancel
      </Button>
      <Button variant="contained" onClick={onConfirm}>
        Send to all
      </Button>
    </DialogActions>
  </Dialog>
);
